import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authenticationService = inject(AuthService);
  const isLoggedIn = authenticationService.checkIfLoggedIn();

  if (isLoggedIn) {
    router.navigate(['/']);
    return false;
  }
  return true;
};
